export { default as CustomDropDown } from './form/CustomDropDown';
export { default as CustomTextArea } from './form/CustomTextArea';
export { default as CustomDatePicker } from './form/CustomDatePicker';
export { default as CustomDateRangePicker } from './form/CustomDateRangePicker';
export { default as CustomInput } from './form/CustomInput';
export { default as ActionButton } from './ActionButton';
export { default as Error } from './Error';
export { default as CustomChipsGroup } from './CustomChipsGroup';
export { default as CustomRadio } from './CustomRadio';
export { default as CustomCollapse } from './CustomCollapse';
export { default as CustomCollapseItem } from './CustomCollapseItem';
export { default as FooterButtons } from './FooterButtons';
export { default as CustomTitleDivider } from './CustomTitleDivider';
export { default as CustomFileInput } from './CustomFileInput';
export { default as AddDiagnosis } from './AddDiagnosis';
export { default as CustomAutoComplete } from './CustomAutoComplete';

// Lista de colores
const colors = Object.freeze({
  GREEN: 'green',
  GREEN_LIGHT: 'green-light',
  BROWN: 'brown',
  YELLOW: 'yellow',
  PINK: 'pink',
  VIOLET: 'violet',
  ORANGE: 'primary-2',
  CHARDONNAY: 'chardonnay',
  RED: 'primary-4',
  GRAY: 'gray-2',
  SWEETCORN: 'secondary-23',
  CELADON: 'celadon',
  ORANGE_LIGHT: 'orange-light',
  AUTUMN_MIST: 'secondary-38',
  PURPLE_LIGHT: 'violet',
  HONEY_LIGHT: 'secondary-24',
});

// Lista de colores
const colorsHexa = Object.freeze({
  PINK: '#f4cbc9',
  BROWN: '#d0b99d',
  YELLOW: '#f6ea8e',
  GREEN_LIGHT: '#b2e3b6',
  PURPLE_LIGHT: '#d6b5d5',
});

export const Colors = colors;
export const ColorsHexa = colorsHexa;
